@if (email) {
  <h1 class="text-center my-2">Onboard meter</h1>
  @if (tpi) {
    <h4 class="text-center my-2">On behalf of {{email}}</h4>
  }
} @else {
  <h1 class="text-center my-2">Register</h1>
}

<div class="d-flex justify-content-center">
  
  <mat-vertical-stepper class="reg-stepper" #stepper [linear]="true" [formGroup]="registrationForm">
    
    <!-- Step 1: Customer Details -->
    <mat-step [stepControl]="registrationForm.get('customerDetails')!" [completed]="isCustomerDetailsValid()">
      <ng-template matStepLabel>Customer Details</ng-template>
      <h4>Provide your details</h4>
      <p>Please provide your details so that we can get to know you better.</p>
      
      <div class="step-content">
        <app-customer-details formControlName="customerDetails"></app-customer-details>
      </div>
      
      <div class="step-buttons">
        <button mat-flat-button matStepperNext [disabled]="!isCustomerDetailsValid()">Next</button>
      </div>
    </mat-step>

    <!-- Step 2: Meter Selection -->
    <mat-step [stepControl]="registrationForm.get('meterSelection')!" [completed]="isMeterSelectionValid()">
      <ng-template matStepLabel>Meter Details</ng-template>
      <h4>Choose how would you like us to access your meter details</h4>
      <p>We need to access your meter details. You can provide us the meter details by either giving us your address details, MPAN directly, or upload a file with multiple meters.</p>
      
      <div class="step-content">
        <app-meter-selection 
          formControlName="meterSelection"
          [multiple]="true">
        </app-meter-selection>
      </div>

      <!-- File upload information message -->
      @if (!isConsentRequired()) {
        <div class="file-upload-info mt-3 p-3" style="background-color: #e3f2fd; border-left: 4px solid #2196f3; border-radius: 4px;">
          <div class="d-flex align-items-start">
            <div>
              <h6 style="margin: 0 0 8px 0; color: #1976d2;">Meter Validation Process</h6>
              <p style="margin: 0; color: #333;">
                We will validate the meters from your uploaded file and send a consent link to your email address. 
                This link will allow you to provide the necessary consent for each meter before they can be onboarded.
              </p>
            </div>
          </div>
        </div>
      }

      <div class="step-buttons">
        <button mat-button matStepperPrevious>Previous</button>
        <button mat-flat-button matStepperNext [disabled]="!isMeterSelectionValid()">Next</button>
      </div>
    </mat-step>

    <!-- Step 3: Consent (only if required) -->
    @if (isConsentRequired()) {
      <mat-step [stepControl]="registrationForm.get('consent')!" [completed]="isConsentValid()">
        <ng-template matStepLabel>Consent</ng-template>
        
        <div class="consent-input-container">
          <app-consent-wallet-fc 
            formControlName="consent"
            [customerDetails]="getCustomerDetailsForConsent()"
            [meterDetails]="getMeterDetailsForConsent()">
          </app-consent-wallet-fc>
        </div>
        
        <div class="step-buttons">
          <button mat-button matStepperPrevious>Previous</button>
          <button mat-flat-button color="primary" matStepperNext [disabled]="!isConsentValid()">Next</button>
        </div>
      </mat-step>
    }
  
    <!-- Step 4: Terms and conditions -->
    <mat-step [completed]="registrationForm.get('agreeToTerms')?.valid">
      <ng-template matStepLabel>Terms and conditions</ng-template>
      <mat-checkbox formControlName="agreeToTerms">
        Accept terms and conditions
      </mat-checkbox>
      <div class="terms-text">
        
      I confirm that I am the occupier and/ or bill payer for this meter, or, if registering on behalf of a company, I am authorised on behalf of the Company who is the occupier of this property and/ or bill payer for this meter, and that I/ we:
      <br/>
      <br/>
      a) Will Opt-in to participate in any Flex Event - I/ we will be notified in advance of a Flex Event and will not participate unless I/ we actively confirm my/ our participation;
      <br/>
      b) Agree to the <a href="https://energyhelp.perse.io/termsandconditions" target="_blank">terms and conditions</a>; and
      <br/>
      c) Agree to the <a href="https://www.perse.io/privacy-policy" target="_blank">privacy policy</a>, noting that this includes giving you consent or permission to obtain my/ our data, which includes energy consumption at half hourly intervals, and that my/ our information may be shared with third parties.

      </div>
      <div class="footer-section">
      @if (!registrationInProgress) {
          <button mat-button matStepperPrevious>Previous</button>
          <button mat-raised-button color="primary" [disabled]="!allStepsValid()" (click)="onSubmit()">Submit</button>
      }
      @if (registrationInProgress) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      </div>
    </mat-step>

  </mat-vertical-stepper>
</div>

